module.exports = __webpack_public_path__ + "img/f1-2-icon3.4aad46cf.png";